// extracted by mini-css-extract-plugin
export default {"mpc-1":"style_mpc-1__ZF13H","mpc-2":"style_mpc-2__KiOqR","my-profile-complete":"style_my-profile-complete__pyTtP"};